<template>
  <div class="candidate-info" v-if="defaultPanel.rows">
    <div class="panel--default" v-if="defaultPanel">
      <div v-for="(rows, idx) in defaultPanel.rows" class="row" :key="idx">
        <div v-for="(item, i) in rows" :key="i" class="item" :class="item.name">
          <div class="column">
            <div v-if="item.lbl && item.type !== 'button'" class="column--left">
              {{ item.lbl }}
            </div>
            <div
              v-if="!item.url"
              :class="item.style_type ? [...item.style_type] : ''"
              class="column--right"
            >
              <Link
                v-if="item.type == 'url' && item.value"
                target="_blank"
                :text="formatHtml(item.value)"
                :href="item.value"
              />
              <template v-else>
                {{
                  formatHtml(
                    item.options
                      ? item.options[item.value]
                      : formatHtml(item.value) || (!i ? 'нет данных' : '')
                  )
                }}
              </template>
            </div>
            <Link
              v-else-if="item.value && item.url"
              target="_blank"
              :text="formatHtml(item.value)"
              :href="item.url"
            />
          </div>
          <FormButtons
            v-if="item.type === 'button'"
            :buttons_menu="[[item]]"
            topPanel
            view-type="detail"
            :class="item.style_type ? [...item.style_type] : ''"
          ></FormButtons>
        </div>
      </div>
    </div>

    <Divider hasLine dividerSize="1" />

    <div class="panel">
      <div class="panel--detail">
        <div
          class="panel__title"
          v-if="totalExperience && totalExperience.visibility != 'hidden'"
        >
          {{ `${totalExperience.title} ${totalExperience.value}` }}
        </div>
        <div class="experience" v-if="detailExperience">
          <div v-for="(item, idx) in detailExperience" :key="idx">
            <div class="detail__column">
              <div class="detail__column--left">
                <div
                  class="experience__date"
                  v-if="
                    (item.period_begin && item.period_begin.value) ||
                    (item.period_end && item.period_end.value)
                  "
                >
                  {{
                    `${item.period_begin.value || ''} &ndash; ${
                      item.period_end.value || 'по настоящее время'
                    }`
                  }}
                </div>
                <div
                  class="experience__length"
                  v-if="item.period_length && item.period_length.value"
                >
                  {{ item.period_length.value }}
                </div>
              </div>
              <div class="detail__column--right">
                <div
                  class="experience__company"
                  v-if="item.company_name && item.company_name.value"
                >
                  {{ item.company_name.value }}
                </div>
                <div
                  class="experience__post"
                  v-if="item.post && item.post.value"
                >
                  {{ item.post.value }}
                </div>
                <div
                  v-if="item.post_desc && item.post_desc.value"
                  class="experience__post-desc"
                  v-html="item.post_desc.value"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="additional-panels">
        <div v-for="panel in additionalPanels" :key="panel.panel_id">
          <div
            class="panel--skills"
            v-if="skillsPanel && panel.panel_id == 'lbl_panel_skills'"
          >
            <div class="panel__title">
              {{ `${skillsPanel.title}` }}
            </div>
            <div class="skill-items">
              <Tag
                :name="skill"
                :closable="false"
                effect="dark"
                v-for="(skill, i) in skillsPanel.skills"
                :key="i"
              ></Tag>
            </div>
          </div>

          <div
            class="panel--about"
            v-if="
              aboutOneselfPanel && panel.panel_id == 'lbl_panel_about_oneself'
            "
          >
            <div class="panel__title">
              {{ `${aboutOneselfPanel.title}` }}
            </div>
            <div class="panel__text" v-html="aboutOneselfPanel.value"></div>
          </div>

          <div
            class="panel--education"
            v-if="educationPanel && panel.panel_id == 'lbl_panel_education'"
          >
            <div class="panel__title">
              {{ `${educationPanel.title}` }}
            </div>
            <div
              v-for="(item, idx) in educationPanel.educationHistory"
              :key="idx"
              class="detail education"
            >
              <div class="detail__title"></div>
              <div class="detail__column">
                <div class="detail__column--left">
                  <div class="education__type">
                    {{ `${item.education_lvl}` }}
                  </div>
                  <div class="education__length">
                    {{
                      item.year_of_graduation == '0'
                        ? ''
                        : item.year_of_graduation
                    }}
                  </div>
                </div>
                <div class="detail__column--right">
                  <div class="education__name">
                    {{ formatHtml(item.university) }}
                  </div>
                  <div>{{ formatHtml(item.specialization) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="panel--training"
            v-if="
              skillsTrainingPanel &&
              panel.panel_id == 'lbl_panel_skills_training'
            "
          >
            <div class="panel__title">
              {{ `${skillsTrainingPanel.title}` }}
            </div>
            <div
              v-for="(item, idx) in skillsTrainingPanel.trainings"
              :key="idx"
              class="detail training"
            >
              <div class="detail__title"></div>
              <div class="detail__column">
                <div class="detail__column--left">
                  <div class="training__date">
                    {{ `${item.year_of_graduation}` }}
                  </div>
                </div>
                <div class="detail__column--right">
                  <div class="training__name">
                    {{ formatHtml(item.organization) }}
                  </div>
                  <div class="training__course">
                    {{ formatHtml(item.course_name) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="panel--languages"
            v-if="
              languagesPanel &&
              panel.panel_id == 'lbl_panel_language_proficiency'
            "
          >
            <div class="panel__title">
              {{ `${formatHtml(languagesPanel.title)}` }}
            </div>
            <div class="panel__languages">
              <div
                class="panel__text"
                v-for="(lang, i) in languagesPanel.languages"
                :key="i"
              >
                {{
                  lang.language_proficiency && lang.language_proficiency_lvl
                    ? `${lang.language_proficiency} — ${
                        lang.language_proficiency_lvl === 'Родной'
                          ? lang.language_proficiency_lvl
                          : lang.language_proficiency_lvl.toUpperCase()
                      }`
                    : ''
                }}
              </div>
            </div>
          </div>
          <div
            class="panel--languages"
            v-if="
              RecommendationsPanel &&
              panel.panel_id == 'lbl_panel_recomendations'
            "
          >
            <div class="panel__title">
              {{ `${formatHtml(RecommendationsPanel.title)}` }}
            </div>
            <div
              class="experience panel__languages"
              v-if="RecommendationsPanel.recommendations"
            >
              <div
                v-for="(
                  recommendations, idx
                ) in RecommendationsPanel.recommendations"
                :key="idx"
              >
                <div class="detail__column">
                  <div class="detail__column--left">
                    <div class="experience__date">
                      {{ formatHtml(recommendations.organization) }}
                    </div>
                  </div>
                  <div class="detail__column--right">
                    <div class="experience__company">
                      {{ formatHtml(recommendations.name) }}
                    </div>
                    <div class="experience__post-desc">
                      {{ formatHtml(recommendations.position) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import { mixin } from '@/utils/mixins';
import { numberWithSpace } from '@/utils/helpers';
import Divider from 'Elements/Divider/Divider';
import FormButtons from 'Elements/Form/FormButtons';
import Tag from 'Elements/Tag/Tag';
import Link from 'Elements/Link/Link';
export default {
  mixins: [mixin],
  props: {
    id: {
      type: String,
      default: 'resume'
    }
  },

  data() {
    return {
      numberWithSpace,
      visibleResumePopup: false
    };
  },
  methods: {
    handleHiddenPanels(panels) {
      const editedPanels = [];
      panels.forEach(panel => {
        if (panel?.rows?.length) {
          if (panel.rows[0].length) {
            panel.rows[0].forEach(field => {
              if (
                !field.hasOwnProperty('visibility') ||
                (field.hasOwnProperty('visibility') &&
                  field?.visibility != 'hidden')
              ) {
                editedPanels.push(panel);
              }
            });
          }
        }
      });
      return editedPanels;
    }
  },
  computed: {
    additionalPanels() {
      return this.handleHiddenPanels(
        store.state.subpanels.activeSubpanelData[this.id].slice(3)
      );
    },
    defaultPanel() {
      const panel = store.state.subpanels.activeSubpanelData
        ? store.state.subpanels.activeSubpanelData[this.id].find(
            el => el.panel_id == 'lbl_default_panel'
          ) || {}
        : {};
      if (panel?.rows?.length) {
        panel.rows.forEach((fieldArr, i) => {
          panel.rows[i] = fieldArr.filter(
            field =>
              !field.hasOwnProperty('visibility') ||
              (field.hasOwnProperty('visibility') &&
                field?.visibility != 'hidden')
          );
        });
      }
      return panel;
    },
    detailExperience() {
      const rows = store.state.subpanels.activeSubpanelData[this.id].find(
        el => el.panel_id == 'lbl_detail_experience_panel'
      )?.rows;
      return rows && rows.length
        ? rows.map(item => {
            if (item.fields && item.fields.length) {
              item.fields.map(field => {
                item[field.name] = field;
              });
              return item;
            } else {
              return [];
            }
          }) || []
        : [];
    },

    totalExperience() {
      let totalExperiencePanel = store.state.subpanels.activeSubpanelData
        ? store.state.subpanels.activeSubpanelData[this.id].find(
            el => el.panel_id == 'lbl_experience'
          ) || {}
        : {};
      return totalExperiencePanel && totalExperiencePanel.rows?.length
        ? {
            title: totalExperiencePanel.lbl,
            visibility: totalExperiencePanel.rows[0][0]?.visibility || 'shown',
            value: totalExperiencePanel.rows[0][0].value
          }
        : null;
    },
    educationPanel() {
      let panel = store.state.subpanels.activeSubpanelData[this.id].find(
        el => el.panel_id == 'lbl_panel_education'
      );

      let educationHistory = [];
      let educationHistoryData =
        panel?.rows?.length && panel.rows[0][0].value
          ? panel.rows[0][0].value
          : [];
      if (educationHistoryData.length) {
        educationHistoryData.forEach(education => {
          let educationData = {};
          education.fields.forEach(field => {
            if (field.name == 'education_lvl') {
              educationData[field.name] =
                !field.value || field.value == 'none'
                  ? ''
                  : field.options[field.value];
            } else {
              educationData[field.name] = field.value;
            }
          });
          educationHistory.push(educationData);
        });
      }

      return panel && educationHistory.length
        ? { title: panel.lbl, educationHistory }
        : null;
    },

    languagesPanel() {
      const panel = store.state.subpanels.activeSubpanelData[this.id].find(
        el => el.panel_id == 'lbl_panel_language_proficiency'
      );

      let languages = [];
      let languagesData =
        panel?.rows?.length && panel.rows[0][0].value
          ? panel.rows[0][0].value
          : [];
      if (languagesData.length) {
        languagesData.forEach(training => {
          let trainingData = {};
          training.fields.forEach(field => {
            if (field.name == 'language_proficiency') {
              trainingData[field.name] = field.options[field.value];
            } else {
              trainingData[field.name] = field.options[field.value];
            }
          });
          languages.push(trainingData);
        });
      }

      return panel && languages.length ? { title: panel.lbl, languages } : null;
    },

    RecommendationsPanel() {
      const panel = store.state.subpanels.activeSubpanelData[this.id].find(
        el => el.panel_id == 'lbl_panel_recomendations'
      );

      let recommendations = [];
      let recommendationsData =
        panel?.rows?.length && panel.rows[0][0].value
          ? panel.rows[0][0].value
          : [];
      if (recommendationsData.length) {
        recommendationsData.forEach(training => {
          let trainingData = {};
          training.fields.forEach(field => {
            trainingData[field.name] = field.value;
          });
          recommendations.push(trainingData);
        });
      }

      return panel && recommendations.length
        ? { title: panel.lbl, recommendations }
        : null;
    },

    aboutOneselfPanel() {
      const panel = store.state.subpanels.activeSubpanelData[this.id].find(
        el => el.panel_id == 'lbl_panel_about_oneself'
      );
      return panel
        ? { title: panel.lbl, value: this.formatHtml(panel.rows[0][0].value) }
        : null;
    },

    skillsTrainingPanel() {
      const panel = store.state.subpanels.activeSubpanelData[this.id].find(
        el => el.panel_id == 'lbl_panel_skills_training'
      );

      let trainings = [];
      let trainingsData =
        panel?.rows?.length && panel.rows[0][0].value
          ? panel.rows[0][0].value
          : [];
      if (trainingsData.length) {
        trainingsData.forEach(training => {
          let trainingData = {};
          training.fields.forEach(field => {
            trainingData[field.name] = field.value;
          });
          trainings.push(trainingData);
        });
      }

      return panel && trainings.length ? { title: panel.lbl, trainings } : null;
    },

    skillsPanel() {
      const panel = store.state.subpanels.activeSubpanelData[this.id].find(
        el => el.panel_id == 'lbl_panel_skills'
      );

      let skills = [];
      let skillsData =
        panel?.rows?.length && panel.rows[0][0].visual_value
          ? panel.rows[0][0].visual_value
          : [];

      if (skillsData.length) {
        skillsData.forEach(skill => {
          skills.push(skill.name);
        });
      } else if (
        panel.rows[0][0].value &&
        typeof panel.rows[0][0].value == 'string'
      ) {
        skills = panel.rows[0][0].value.split(',');
      }

      return panel && skills.length ? { title: panel.lbl, skills } : null;
    }
  },
  components: { Divider, FormButtons, Tag, Link }
};
</script>

<style lang="scss" scoped>
.candidate-info {
  .panel {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;

    .additional-panels {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    &__title {
      font-weight: 700;
      font-size: 18px;
      line-height: 28px;
      color: $grey64;
    }

    &__text {
      font-size: 15px;
      line-height: 24px;
    }

    &__languages {
      display: flex;
      flex-direction: column;
      margin-top: 8px;
    }

    &--default {
      padding: 0 24px;
      .row {
        display: flex;
        margin-bottom: 8px;
        line-height: 24px;

        &:first-child {
          margin-top: 16px;
          margin-bottom: 10px;
        }

        &:last-child {
          margin-bottom: 18px;
        }

        & .specialty,
        .salary_group > div > div {
          color: $grey80;
          font-family: 'Roboto', sans-serif;
          font-weight: 700;
          font-size: 24px;
          line-height: 24px;
        }

        .item {
          display: flex;
          justify-content: space-between;
          width: 100%;

          &.salary_group,
          &.open_resume_fulltext ::v-deep .buttons-panel__buttons {
            flex-flow: row-reverse;
          }

          & :has(.fixed) {
            width: 100%;
            display: flex;
            justify-content: flex-end;
          }

          .fixed {
            width: 100%;
            display: flex;
            justify-content: flex-end;
          }

          & .column {
            display: flex;
            align-items: center;
            &--left {
              margin-right: 16px;
              width: 140px;
              font-size: 15px;
              color: $grey40;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }

    .detail {
      width: 100%;

      &__column {
        display: flex;
        width: 100%;
        margin-right: 25px;

        &--left {
          max-width: 139px;
          min-width: 139px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          overflow: hidden;
          font-size: 15px;

          .education__length,
          .period__length {
            color: $grey40;
          }
        }
        &--right {
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 24px;
          color: $grey80;

          .education__name,
          .training__name {
            font-weight: 700;
            font-size: 15px;
          }
        }
      }
    }

    &--skills {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .skill-items {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        & > .el-tag {
          background: $blue40;
        }
      }
    }

    &--about {
      & ::v-deep .panel__text > p {
        margin-top: 8px;
        font-size: 15px;
        line-height: 24px;
      }
    }

    .experience,
    &--detail,
    &--training,
    &--education {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .experience {
      &__length {
        color: $grey40;
      }

      &__company,
      &__post {
        font-weight: 700;
        font-size: 15px;
      }
    }
  }
}
</style>
